import { PieChart, PieChartProps } from '../../../../renderers/pie-chart/pie-chart.component';
import { PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_DEFINITION } from './pudo-transaction-volume-by-slot-dimension-donut-chart.definition';
import { PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_MOCK_DATA } from './pudo-transaction-volume-by-slot-dimension-donut-chart.mock';

export const PudoTransactionVolumeBySlotDimensionDonutChart = (props: PieChartProps) => (
    <PieChart
        {...props}
        variant='donut'
        showSliceValues
    />
);

PudoTransactionVolumeBySlotDimensionDonutChart.definition = PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_DEFINITION;
PudoTransactionVolumeBySlotDimensionDonutChart.mockData = PUDO_TRANSACTION_VOLUME_BY_SLOT_DIMENSION_DONUT_CHART_MOCK_DATA;
